import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EndpointService } from '@app/core';
import { Observable } from 'rxjs/Observable';
import { EmailSmtp } from '@app/shared';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class SmtpManagementDataService {

  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }

  getSmtp(id: number): Observable<EmailSmtp[]> {
    return new Observable(obs => {
      return this.http.get<EmailSmtp[]>(this.api.get('emailSmtpCompany', [id])).subscribe(
        smtp => obs.next(smtp),
        err =>  obs.error(err)
      );
    });
  }

  /**
   * Actualizar la empresa del usuario logueado
   *
   * @param {number} id
   * @param {EmailSmtp} smtp
   * @returns {Promise<boolean>}
   * @memberof SmtpManagementDataService
   */
  updateSmtp(id: number, smtp: EmailSmtp): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.put<boolean>(this.api.get('emailSmtp', [id]), smtp).subscribe(
        _resp => {
          this.toastr.success('Smtp modificada correctamente' , 'Operación exitosa');
          resolve(true);
        },
        err => {
          reject(err);
        }
      );
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-system/smtp-management/shared/smtp-management-data.service.ts